module.exports = __webpack_public_path__ + "img/6_Fundus.c2c4e30f.png";